import React, { useContext, useEffect, useRef, useState } from 'react'
import ManualConfigs from './manualConfig/ManualConfigs'
import PlayButton from './playButton/PlayButton'
import AutoConfig from './autoConfig/AutoConfig'
import { CONFIGS_PROPS } from './interface'
import useStateUpdate from './helpers/useStateUpdate'
import { defaultAutoConfigs } from '../../lib/defaultValues'
import { handleInputCalculations } from './helpers/handleCalculateInputs'
import useLogs from './helpers/autoplay/autoplayLogs'
import useSound from 'use-sound'
import SliderSFX from '../../lib/audio/slider.mp3'
import WinSFX from '../../lib/audio/win.mp3'
import { sendConfigs } from '../../settings/useSettings'
import { MyContext } from '../../context/createContext'
import {
  handleSaveConfigHelper,
  handleAutoHelper,
} from './helpers/configHelpers'

export default function Configs({
  handleRollUnder,
  handleAbove,
  autoConfig,
  handleAutoConfigs,
  playClick,
  focusedHandler,
  focused,
  handleSetAutoConfig,
  errorCode,
  finalBalance,
  audio,
  winHandler,
  prec,
}: CONFIGS_PROPS) {
  const { context } = useContext(MyContext)
  const {
    handleAutoConfigCTX,
    activeConfig,
    autoConfigOne,
    autoConfigTwo,
    autoConfigThree,
    stake,
    baseStake,
    handleStake,
    handleBaseStake,
    manualConfigs,
    handleRollUnderValue,
    sliderValue,
    rollUnder,
    isError,
    bet,
    handleNotification,
    notification,
    handleSliderValueCTX,
    diceSocketMessages,
    auth,
    settings,
    config,
  } = context

  const { minbet, maxbet, rake } = config
  const { bankroll } = settings
  const {
    balance: { currency },
  } = auth

  const [onWin, setonWin] = useState(true)
  const [onLoss, setonLoss] = useState(true)

  const handleonWin = (b: boolean) => {
    setonWin(!b)
  }
  const handleonLoss = (b: boolean) => {
    setonLoss(!b)
  }

  const {
    autoRollNumber,
    autoMaxStake,
    stopOnProfit,
    stopOnLoss,
    onWinPercent,
    onLossPercent,
    handleStateUpdate,
  } = useStateUpdate(handleStake)

  const [playSliderSFX] = useSound(SliderSFX, {
    volume: parseFloat(audio.sound) / 100,
  })
  const [playWinSFX] = useSound(WinSFX, {
    volume: parseFloat(audio.sound) / 100,
  })

  const [finalStake, setFinalStake] = useState('0.00')
  const [multiplier, setMultiplier] = useState('')
  const [winchance, setwinchance] = useState('')
  const [autoData, setautoData] = useState(defaultAutoConfigs)
  const [autoReady, setautoReady] = useState(false)
  const [startAuto, setstartAuto] = useState(false)
  const [isDisablePlay, setisDisablePlay] = useState<boolean>(false)
  const [betCount, setbetCount] = useState(0)
  const [step, setStep] = useState<string>('')
  const [lastBetId, setlastBetId] = useState('')
  const [active, setActive] = useState<number>(activeConfig)
  const [ggr, setggr] = useState(0)
  const myTimeout = useRef<any>(null)
  const handleStartAuto = (b: boolean) => {
    setstartAuto(b)
    handleSetAutoConfig(b)
  }
  useEffect(() => {
    !!notification && setstartAuto(false)
  }, [notification])

  useEffect(() => {
    bet.win > 0 && !audio.isSoundOff && playWinSFX()
    setTimeout(() => {
      setisDisablePlay(false)
    }, 300)
  }, [bet, startAuto])

  const handleAutoReady = (b: boolean) => {
    setbetCount(0)
    setautoReady(b)
    if (Number(stake) >= Number(maxbet)) {
      handleStake(maxbet.toString())
    }
  }

  const handleChance = (s: string) => setwinchance(s)
  const handleMultiplier = (s: string) => setMultiplier(s)
  const handleFinalStake = (s: string) => setFinalStake(s)

  const handleSliderValue = (value: any) => {
    !audio.isSoundOff && playSliderSFX()
    handleSliderValueCTX(value)
    handleInputCalculations(
      value,
      rollUnder,
      rake,
      bankroll,
      stake,
      handleMultiplier,
      handleFinalStake,
      handleChance,
    )
  }

  const handleManual = () => {
    if (startAuto) handleStartAuto(false)
    handleAutoReady(false)
    handleAutoConfigs(false)
    handleStake(
      Number(manualConfigs.stake) <= 0
        ? minbet.toFixed(prec)
        : manualConfigs.stake,
    )
    handleSliderValue(manualConfigs.sliderValue)
    handleRollUnderValue(manualConfigs.rollUnder)
  }

  const resetAuto = () => {
    handleStartAuto(false)
    setbetCount(0)
    setggr(0)
    setStep('')
    setlastBetId('')
    setpouseauto(true)
  }

  useEffect(() => {
    if (!autoReady) {
      handleStake &&
        handleStake(
          settings.stake === '0' || settings.stake === ''
            ? Number(minbet).toFixed(prec).toString()
            : settings.stake,
        )
      if (settings.bankroll < 100 && settings.bankroll > 0) {
        handleSliderValue(settings.bankroll)
        // setRollForSocket(settings.bankroll) ეს ბაგავდა როდესაც ჯერ სლაიდერი იცვლება და შემდეგ ბეთი
      }
      const up = settings.over_or_under == '1' ? '1' : '0'
      handleRollUnderValue(up)
    }
  }, [settings, minbet])

  const [rollForSocket, setRollForSocket] = useState(sliderValue)
  const [pouseauto, setpouseauto] = useState(false)

  useEffect(() => {
    winHandler(bet.win)
  }, [bet])

  const handleAuto = () => {
    handleAutoHelper(
      stake,
      baseStake,
      sliderValue,
      rollUnder == '0' ? '0' : '1',
      finalBalance,
      handleNotification,
      resetAuto,
      lastBetId,
      setlastBetId,
      bet,
      myTimeout,
      betCount,
      autoRollNumber,
      stopOnLoss,
      stopOnProfit,
      ggr,
      autoMaxStake,
      setStep,
      diceSocketMessages,
      onLoss,
      onLossPercent,
      onWin,
      onWinPercent,
      setggr,
      handleStake,
      rake,
      pouseauto,
      setpouseauto,
      maxbet,
      currency,
      setbetCount,
    )
  }
  //log auto stops fot testing
  useLogs(step, autoData, handleNotification, currency, resetAuto, prec)

  useEffect(() => {
    handleInputCalculations(
      sliderValue,
      rollUnder,
      rake,
      bankroll,
      stake,
      handleMultiplier,
      handleFinalStake,
      handleChance,
    )
  }, [rollUnder, sliderValue, stake, rake])

  // update auto configs object when AUTO IS READY (set autoplay button)
  useEffect(() => {
    autoReady &&
      setautoData({
        stake: stake,
        rollAmount: autoRollNumber,
        onWin: onWin,
        onWinPercent: onWinPercent,
        onLoss: onLoss,
        onLossPercent: onLossPercent,
        stopOnLoss: stopOnLoss,
        stopOnWin: stopOnProfit,
        maxStake: autoMaxStake,
      })
  }, [autoReady, stake])

  useEffect(() => {
    if (startAuto) {
      handleAuto()
    }
    if (!startAuto && (autoRollNumber === '0' || autoRollNumber === '')) {
      setbetCount(0)
    }
  }, [startAuto, bet])

  useEffect(() => {
    if (errorCode !== 0) {
      handleStartAuto(false)
      setpouseauto(true)
      resetAuto()
    }
  }, [errorCode])

  useEffect(() => {
    isError &&
      setTimeout(() => {
        setisDisablePlay(false)
      }, 300)
  }, [isError])

  useEffect(() => {
    if (errorCode !== 0 && isDisablePlay) {
      setTimeout(() => {
        setisDisablePlay(false)
      }, 300)
    }
  }, [errorCode, isDisablePlay])

  useEffect(() => {
    if (!startAuto) {
      clearTimeout(myTimeout.current)
      setlastBetId('')
    }
  }, [startAuto])
  const handleSaveConfig = () => {
    //send to socket this data
    const autoConfig = {
      stake: stake,
      rollAmount: autoRollNumber,
      onWin: onWin,
      onWinPercent: onWinPercent,
      onLoss: onLoss,
      onLossPercent: onLossPercent,
      stopOnLoss: stopOnLoss,
      stopOnWin: stopOnProfit,
      maxStake: autoMaxStake,
      rollNumber: sliderValue,
      rollUnder: rollUnder,
      isSaved: '1',
    }
    handleSaveConfigHelper(
      autoConfig,
      autoConfigOne,
      autoConfigTwo,
      autoConfigThree,
      handleAutoConfigCTX,
      sendConfigs,
      setActive,
      active,
      handleStake,
      handleRollUnderValue,
      handleSliderValue,
      settings,
    )
  }
  useEffect(() => {
    if (autoConfigOne.isSaved != '0') {
      autoConfig && handleConfig(active)
    }
  }, [autoConfig])

  const handleConfig = (id: number) => {
    if (id === 1) {
      setData(autoConfigOne)
      setActive(1)
    } else if (id === 2) {
      setData(autoConfigTwo)
      setActive(2)
    } else {
      setData(autoConfigThree)
      setActive(3)
    }
  }

  const setData = (data: any) => {
    setautoData({
      stake: data.stake,
      rollAmount: data.rollAmount,
      onWin: data.onWin,
      onWinPercent: data.onWinPercent,
      onLoss: data.onLoss,
      onLossPercent: data.onLossPercent,
      stopOnLoss: data.stopOnLoss,
      stopOnWin: data.stopOnWin,
      maxStake: data.maxStake,
    })
    handleRollUnderValue(data.rollUnder)
    handleSliderValue(data.rollNumber)
    handleStake(data.stake)
    handleBaseStake(data.stake) // update base stake when data is updated
  }

  useEffect(() => {
    if (active === 1) {
      setonLoss(autoConfigOne.onLoss)
      setonWin(autoConfigOne.onWin)
    } else if (active === 2) {
      setonLoss(autoConfigTwo.onLoss)
      setonWin(autoConfigTwo.onWin)
    } else if (active === 3) {
      setonLoss(autoConfigThree.onLoss)
      setonWin(autoConfigThree.onWin)
    }
  }, [active])

  useEffect(() => {
    setautoData({ ...autoData, onWin: onWin })
  }, [onWin])

  useEffect(() => {
    setautoData({ ...autoData, onLoss: onLoss })
  }, [onLoss])
  return (
    <>
      <ManualConfigs
        multiplier={multiplier}
        winchance={winchance}
        autoConfig={autoConfig}
        autoRoll={autoReady}
        setAutoRoll={setautoReady}
        handleSliderValue={handleSliderValue}
        socketValue={rollForSocket}
        focusedHandler={focusedHandler}
        handleStake={handleStateUpdate}
        handleAutoConfigs={handleAutoConfigs}
        handleManual={handleManual}
        handleAbove={handleAbove}
        handleChance={handleChance}
        handleMultiplier={handleMultiplier}
        handleRollUnder={handleRollUnder}
        focused={focused}
        startAuto={startAuto}
        audio={audio}
        active={active}
        resetAuto={resetAuto}
        prec={prec}
      />
      {!autoConfig && (
        <PlayButton
          finalStake={finalStake}
          autoRollNumber={autoRollNumber}
          betCount={betCount}
          autoReady={autoReady}
          diceSocketMessages={diceSocketMessages}
          playClick={playClick}
          handleStartAuto={handleStartAuto}
          startAuto={startAuto}
          setisDisablePlay={setisDisablePlay}
          isDisablePlay={isDisablePlay}
          prec={prec}
        />
      )}
      {autoConfig && (
        <AutoConfig
          handleAutoConfigs={handleAutoConfigs}
          handleStartAuto={handleStartAuto}
          handleAutoReady={handleAutoReady}
          handleStateUpdate={handleStateUpdate}
          handleManual={handleManual}
          audio={audio}
          handleSaveConfig={handleSaveConfig}
          autoData={autoData}
          handleConfig={handleConfig}
          active={active}
          handleonWin={handleonWin}
          handleonLoss={handleonLoss}
          prec={prec}
        />
      )}
    </>
  )
}
